module.exports = __webpack_public_path__ + "resources/images/transparantmac-e7cebaa2fa740007e2d8c9ad3e1838ae-cache.png";